// extracted by mini-css-extract-plugin
export default {"span-two-cols-in-grid":"TextArea_span-two-cols-in-grid__biyoB"};